export default "__VITE_ASSET__CVaNLDly__"